import React from 'react'
import { useParams } from 'react-router-dom'
import FundingService from '../../service/FundingService'
import Funding, { FundingRetrieve } from '../../domain/Funding'
import { statusLabel } from '../../domain/Status'
import useEntity from '../../hooks/useEntity'
import { paths } from '../../routes'
import FindBox from '../ui/FindBox'
import EntityState from '../ui/EntityState'
import EntitySummary from '../ui/EntitySummary'
import StatusChanger from '../ui/StatusChanger'

const FundingUpdateForm: React.FC = () => {
    const { id } = useParams()
    const {
        entity: funding,
        setEntity,
        loading,
        error,
        find,
        refresh,
    } = useEntity<FundingRetrieve>({
        kind: 'funding',
        id,
        retrieve: (fundingId) => FundingService.retrieve(fundingId),
        pathFor: paths.funding.update,
        notFound: 'Funding not found. Check the ID and try again.',
        remember: (found) => ({ label: found.reference }),
    })

    const changeStatus = (status: string) =>
        FundingService.update({ fundingId: funding?.id as string, status }).then(() => setEntity((current) => current && { ...current, status }))

    return (
        <div className="stack">
            <FindBox kind="funding" title="Find a Funding" placeholder="Enter Funding ID" value={id} loading={loading} onFind={find} />
            <EntityState id={id} loading={loading} error={error} ready={!!funding} emptyText="Enter a Funding ID above, or pick a recent one.">
                {funding && (
                    <>
                        <EntitySummary
                            title="Funding Information"
                            status={funding.status}
                            statusLabel={statusLabel(funding.status, Funding.statuses(funding))}
                            items={[
                                { label: 'Funding ID', copy: funding.id },
                                { label: 'Reference', value: funding.reference },
                            ]}
                            refreshing={loading}
                            onRefresh={refresh}
                        />
                        <StatusChanger
                            noun="funding"
                            current={funding.status}
                            statuses={Funding.statuses(funding)}
                            journey={Funding.journey}
                            hints={Funding.hints}
                            onSubmit={changeStatus}
                        />
                    </>
                )}
            </EntityState>
        </div>
    )
}

export default FundingUpdateForm
